import '../sass/serp.scss';
import PageLoaderService from '../ts/service/page-loader-service.ts';

PageLoaderService.init();

const serpDependencies = [
  'ngSanitize',
  'jrCommonDirective',
  'jrCommonService',
  'jrCommonController',
  'jrSerpService',
  'jrSerpDirective',
  'jrSerpItem',
  'jrAutocompleteEmail',
  'jrBannerFixed',
  'jrCookieConsent',
  'jrFavouriteJobsModule',
  'jrLocationInput',
  'jrRegistration',
  'jrModal',
  'jrInlineProposal',
  'jrProposal',
  'jrSerpAdvert',
  'ngAnimate',
  'ui.bootstrap',
];

angular.module('jrSerp', serpDependencies, [
  '$interpolateProvider',
  function ($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
  },
]);
